import { defineComponent, h } from 'vue';
import { coming_soon } from '@components/icons';
import BarButton from '@components/bar-button';
import show_wireframe_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/show_wireframe.svg';
import { img } from '@phi/components';
import ShowWireframeTooltip from './ShowWireframeTooltip';

export const ShowWireframeIcon = show_wireframe_svg;

export default defineComponent({
    props: {
        tut_stage: { required: true, type: Number },
        loaded: { required: true, type: Boolean },
        wireframe_visible: { required: true, type: Boolean },
        is_demo: { required: true, type: Boolean },
        editing_ref: { required: true, type: Boolean },
    },

    emits: {
        'update:wireframe_visible': (x: boolean) => true,
    },

    computed: {
        coming_soon() {
            return !this.loaded;
        },

        alt() {
            return 'Show/hide wireframe';
        },

        disabled() {
            return this.editing_ref;
        },
    },

    render() {
        return h(BarButton, {
            id: 'show-wireframe-button',
            active: this.wireframe_visible,
            disabled: this.disabled,
            selected: this.tut_stage === 3,
            tippy: 'top',
            onClick: !this.coming_soon
                ? () => this.$emit('update:wireframe_visible', !this.wireframe_visible)
                : () => false,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_wireframe_svg, this.alt),
            tooltip: ShowWireframeTooltip,
        });
    },
});
